import React from "react";
import {
  useMyProfileQuery,
  useGetManageReferralsQuery,
  useGetManageTabsStatusQuery,
  useGetWithdrawTabStatusQuery,
  useGetChatTabStatusQuery,
  useGetNotificationsQuery,
} from "../../../services/userApi";
// Added this import based on the App's Header condition (adjust path if needed for your web project)
import { useGetappwithrawtabstatusQuery } from "../../../services/withdrawApi";
import { FiUser, FiLogOut } from "react-icons/fi";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { SlInfo } from "react-icons/sl";
import { removeLocalStorage } from "../../../utils/function/localStorage";
import "./HeaderDropdown.css";
import { useNavigate } from "react-router-dom";
import { IoMdNotifications } from "react-icons/io";
import {
  IoRocketOutline,
  IoChatbubbleEllipsesOutline,
  IoWalletOutline,
  IoChatbubblesOutline,
  IoSwapHorizontalOutline,
  IoShieldCheckmarkOutline,
  IoAppsOutline
} from "react-icons/io5";
import pointsIcon from "../../../assets/images/Point.png";
import { FeedbackOutlined } from "@mui/icons-material";
import { useTheme } from "../../../context/ThemeContext";

const HeaderDropDown = ({ visible, setVisible }) => {
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();

  // 1. Fetch user profile
  const { data } = useMyProfileQuery();
  const username = data?.data?.[0]?.username;

  const { data: notifications } = useGetNotificationsQuery(
    { type: "bell icon" },
    { skip: !username }
  );

  // 2. Fetch all necessary tab statuses
  const { data: manageReferralsData } = useGetManageReferralsQuery();
  const { data: manageTabsData } = useGetManageTabsStatusQuery();

  const { data: withdrawStatus } = useGetWithdrawTabStatusQuery(
    { username },
    { skip: !username }
  );
  const { data: chatStatus, isLoading: isChatStatusLoading } = useGetChatTabStatusQuery(
    { username },
    { skip: !username }
  );

  // App's status query specifically for Point Transfer (mirrored from React Native App logic)
  const { data: appWithdrawStatusData } = useGetappwithrawtabstatusQuery(
    {},
    { skip: !visible }
  );
  // console.log("assignedConversationtype",appWithdrawStatusData)
  let assignedConversationTypes = appWithdrawStatusData?.assignedConversationTypes || [];



  const handleLogout = () => {
    removeLocalStorage("tp_Aa_uth_access");
    removeLocalStorage("userCountry");
    window.location.reload();
  };

  // 3. Conditional rendering logic
  const showWithdrawTab =
    (withdrawStatus?.result?.ManageWithDrawTab === true || appWithdrawStatusData?.status === true) &&
    data?.data?.[0]?.showWithdrawTabInBusiness !== false;

  // const showChatTab = !isChatStatusLoading && chatStatus?.result?.showChatTabInApp !== false;
  const showChatTab = appWithdrawStatusData?.chatTabStatus === true;

  const showPointTransferTab = appWithdrawStatusData?.pointTransferTabStatus === true;

  const showKycTab = appWithdrawStatusData?.kycTabStatusBusiness === true;

  const showPlatformTab = appWithdrawStatusData?.platformTabStatus === true;

  const calculateAvailablePoints = () => {
    if (!data?.data?.[0]) return 0;
    const user = data.data[0];

    let points = 0;
    if (!user.isEmailVerified)
      points += manageReferralsData?.data?.profile_email_update;
    if (
      (user.country === "India" ||
        user.country === "Pakistan" ||
        user.country === undefined) &&
      !user.isMobileVerified
    )
      points += manageReferralsData?.data?.profile_mobile_update;
    if (!user.dob) points += manageReferralsData?.data?.profile_dob_update;
    if (!user.gender)
      points += manageReferralsData?.data?.profile_gender_update;
    if (!user.address)
      points += manageReferralsData?.data?.profile_address_update;
    if (!user.profile_image_status)
      points += manageReferralsData?.data?.profile_avatar_update;
    if (!user.isKYCVerified)
      points += manageReferralsData?.data?.profile_kyc_update;
    if (!user.country)
      points += manageReferralsData?.data?.profile_country_update;
    if (!user.whatsapp)
      points += manageReferralsData?.data?.profile_whatsapp_update;

    return points;
  };

  const getContainerWidth = () => {
    if (data?.data[0]?.is_premium) return "280px";
    return "242px";
  };

  return (
    <div
      className="headerDropdown-container"
      style={{
        top: visible ? "calc(100% + 8px)" : "-800px",
        width: getContainerWidth(),
      }}
    >
      <div className="headerDropdown-inner-container">
        <button
          className="headerDropdown-item"
          onClick={() => {
            navigate("/home/my-profile");
            setVisible(false);
          }}
        >
          <span>
            <FiUser /> My Profile
          </span>
          {calculateAvailablePoints() > 0 && (
            <div className="headerDropdown-points-badge">
              <span>Get {calculateAvailablePoints()}</span>
              <img
                src={pointsIcon}
                alt="points"
                className="headerDropdown-points-icon"
              />
            </div>
          )}
          <span
            className="membership-badge"
            style={{
              backgroundColor: isDarkMode ? 'transparent' : (data?.data[0]?.is_premium
                ? "#4CAF50"
                : "#2f68fd"),
              border: isDarkMode ? `1px solid ${data?.data[0]?.is_premium ? "#4CAF50" : "#2f68fd"}` : 'none',
              padding: "3px 5px !important",
              borderRadius: "5px !important",
              fontSize: 12,
              color: isDarkMode ? (data?.data[0]?.is_premium ? "#4CAF50" : "#4FACFE") : "#fff",
            }}
          >
            {data?.data[0]?.is_premium
              ? "Premium"
              : "Free"}
          </span>
        </button>

        <button
          className="headerDropdown-item"
          onClick={() => {
            navigate("/home/notification");
            setVisible(false);
          }}
        >
          <span>
            <IoMdNotifications size={18} style={{ marginRight: '6px' }} /> Notifications
          </span>
          {notifications?.pagination?.total > 0 && (
            <div className="headerDropdown-points-badge" style={{ backgroundColor: '#EF4444', borderRadius: '10px', padding: '1px 6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ color: '#ffffff', fontSize: '10px', fontWeight: 'bold' }}>{notifications?.pagination?.total}</span>
            </div>
          )}
        </button>

        {/* {!data?.data[0]?.is_premium && (
          <button
            className="headerDropdown-item"
            onClick={() => {
              navigate("/home/premium");
              setVisible(false);
            }}
          >
            <span>
              <IoRocketOutline /> Activate Premium
            </span>
          </button>
        )} */}

        {/* --- CONDITIONAL MODERATOR ROUTES START --- */}
        {showWithdrawTab && (
          <button
            className="headerDropdown-item"
            onClick={() => {
              navigate("/home/moderatorwithdraw");
              setVisible(false);
            }}
          >
            <span>
              <IoWalletOutline size={20} /> Withdraw Moderator
            </span>
          </button>
        )}

        {showChatTab &&
          (assignedConversationTypes.includes('help') ||
            assignedConversationTypes.length === 0) && (
            <button
              className="headerDropdown-item"
              onClick={() => {
                navigate("/home/chat-moderator?option=help");
                setVisible(false);
              }}
            >
              <span>
                <IoChatbubblesOutline size={20} />Support Chat Moderator
              </span>
            </button>
          )}
        {showChatTab &&
          (assignedConversationTypes.includes('admin') ||
            assignedConversationTypes.length === 0) && (
            <button
              className="headerDropdown-item"
              onClick={() => {
                navigate("/home/chat-moderator?option=admin");
                setVisible(false);
              }}
            >
              <span>
                <IoShieldCheckmarkOutline size={20} /> Review Chat Moderator
              </span>
            </button>
          )}

        {showPointTransferTab && (
          <button
            className="headerDropdown-item"
            onClick={() => {
              navigate("/home/ModeratorPointTransfer");
              setVisible(false);
            }}
          >
            <span>
              <IoSwapHorizontalOutline size={20} /> Point Transfer Moderator
            </span>
          </button>
        )}

        {showKycTab && (
          <button
            className="headerDropdown-item"
            onClick={() => {
              navigate("/home/kyc-moderator");
              setVisible(false);
            }}
          >
            <span>
              <IoWalletOutline size={20} /> KYC Moderator
            </span>
          </button>
        )}
        {showPlatformTab && (
          <button
            className="headerDropdown-item"
            onClick={() => {
              navigate("/home/platform-moderator");
              setVisible(false);
            }}
          >
            <span>
              <IoAppsOutline size={20} /> Platform Moderator
            </span>
          </button>
        )}
        {/* --- CONDITIONAL MODERATOR ROUTES END --- */}

        <button
          className="headerDropdown-item"
          onClick={() => {
            navigate("/home/help-and-support");
            setVisible(false);
          }}
        >
          <span>
            <TfiHeadphoneAlt /> Help and Support
          </span>
        </button>

        <button
          className="headerDropdown-item"
          style={{ color: '#FF7F50' }}
          onClick={() => {
            navigate("/home/chat-with-us");
            setVisible(false);
          }}
        >
          <span>
            <IoChatbubbleEllipsesOutline color='#FF7F50' size={22} /> Chat with US
          </span>
        </button>

        <button
          className="headerDropdown-item"
          onClick={() => {
            navigate("/home/feedback");
            setVisible(false);
          }}
        >
          <span>
            <FeedbackOutlined /> Feedback
          </span>
        </button>

        <button
          className="headerDropdown-item"
          onClick={() => {
            navigate("/home/FAQ");
            setVisible(false);
          }}
        >
          <span>
            <span style={{ fontSize: '20px' }}>?</span> FAQ
          </span>
        </button>

        <button
          className="headerDropdown-item"
          onClick={() => {
            navigate("/home/about");
            setVisible(false);
          }}
        >
          <span>
            <SlInfo /> About
          </span>
        </button>

        <button
          className="headerDropdown-item"
          onClick={() => {
            navigate("/home/platform-listing");
            setVisible(false);
          }}
        >
          <span>
            <IoAppsOutline size={20} /> Platform Listing
          </span>
        </button>

        <button className="headerDropdown-item" onClick={handleLogout}>
          <span>
            <FiLogOut /> Sign Out
          </span>
        </button>
      </div>
    </div>
  );
};

export default HeaderDropDown;